import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

type Props = {
	label: string;
	isAlert?: boolean;
	minWidth?: number;
	compact?: boolean;
};

export const TimerChip = ({
	label,
	isAlert,
	minWidth = 80,
	compact,
}: Props) => {
	const theme = useAppTheme();
	const color = isAlert ? theme.colors.error : theme.colors.onSurface;

	return (
		<Box flexDirection="row" alignItems="center" gap={4}>
			<Icon name="clock-outline" size={compact ? 14 : 18} color={color} />
			<Box minWidth={minWidth} alignItems="flex-start">
				<Text
					variant={compact ? "labelMedium" : "bodyLarge"}
					style={{ textAlign: "right", fontWeight: "700", color }}
				>
					{label}
				</Text>
			</Box>
		</Box>
	);
};

export default TimerChip;
